'use client';

import { ReactNode, useEffect, useState } from 'react';
import { ProjectModel } from '@/lib/models/Project';
import { DesktopShell } from '@/components/DesktopShell';
import { MobileShell } from '@/components/MobileShell';
import { DeviceContext } from '@/components/DeviceContext';
import { MOBILE_MAX_WIDTH } from '@/lib/config';

interface Props {
  children: ReactNode;
  projects: ProjectModel[];
  initialIsMobile: boolean;
}

const MOBILE_QUERY = `(max-width: ${MOBILE_MAX_WIDTH}px)`;

export function SiteShell({ children, projects, initialIsMobile }: Props) {
  const [isMobile, setIsMobile] = useState(initialIsMobile);

  useEffect(() => {
    const mq = window.matchMedia(MOBILE_QUERY);
    const sync = () => {
      setIsMobile((prev) => (prev === mq.matches ? prev : mq.matches));
    };
    sync();
    mq.addEventListener('change', sync);
    return () => {
      mq.removeEventListener('change', sync);
    };
  }, []);

  return (
    <DeviceContext.Provider value={isMobile}>
      {isMobile ? (
        <MobileShell projects={projects}>{children}</MobileShell>
      ) : (
        <DesktopShell projects={projects}>{children}</DesktopShell>
      )}
    </DeviceContext.Provider>
  );
}
